import { gql } from '@apollo/client';

export const CUSTOMER_FIELDS = gql`
  fragment CustomerFields on Customer {
    id
    branch_id
    first_name
    last_name
    phone
    phone_normalized
    email
    rfc
    tax_regime
    postal_code
    cfdi_usage
    fiscal_legal_name
    fiscal_email
    notes
    status
    created_at
    updated_at
  }
`;

export const CUSTOMERS_QUERY = gql`
  ${CUSTOMER_FIELDS}
  query Customers($offset: Int, $limit: Int, $search: String, $status_filter: CatalogStatusFilter) {
    customers(offset: $offset, limit: $limit, search: $search, status_filter: $status_filter) {
      items {
        ...CustomerFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CUSTOMER_QUERY = gql`
  ${CUSTOMER_FIELDS}
  query Customer($id: ID!) {
    customer(id: $id) {
      ...CustomerFields
    }
  }
`;

export const RESOLVE_PET_QR_QUERY = gql`
  query ResolvePetQrForStaff($token: String!) {
    resolvePetQrForStaff(token: $token) {
      customer_id
      customer_name
      pet_id
      pet_name
    }
  }
`;

export const LOOKUP_CUSTOMER_DUPLICATES_QUERY = gql`
  ${CUSTOMER_FIELDS}
  query LookupCustomerDuplicates($input: CustomerDuplicateLookupInput!) {
    lookupCustomerDuplicates(input: $input) {
      customer {
        ...CustomerFields
      }
      match_score
      match_reason
    }
  }
`;

export const CREATE_CUSTOMER_MUTATION = gql`
  ${CUSTOMER_FIELDS}
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      ...CustomerFields
    }
  }
`;

export const UPDATE_CUSTOMER_MUTATION = gql`
  ${CUSTOMER_FIELDS}
  mutation UpdateCustomer($id: ID!, $input: UpdateCustomerInput!) {
    updateCustomer(id: $id, input: $input) {
      ...CustomerFields
    }
  }
`;

export const SET_CUSTOMER_STATUS_MUTATION = gql`
  ${CUSTOMER_FIELDS}
  mutation SetCustomerStatus($id: ID!, $status: String!) {
    setCustomerStatus(id: $id, status: $status) {
      ...CustomerFields
    }
  }
`;

export const CUSTOMER_SECONDARY_PHONES_QUERY = gql`
  query CustomerSecondaryPhones($id: ID!) {
    customer(id: $id) {
      id
      secondary_phones {
        id
        customer_id
        phone
        label
        created_at
      }
    }
  }
`;

export const ADD_CUSTOMER_SECONDARY_PHONE_MUTATION = gql`
  mutation AddCustomerSecondaryPhone($input: AddCustomerSecondaryPhoneInput!) {
    addCustomerSecondaryPhone(input: $input) {
      id
      customer_id
      phone
      label
      created_at
    }
  }
`;

export const REMOVE_CUSTOMER_SECONDARY_PHONE_MUTATION = gql`
  mutation RemoveCustomerSecondaryPhone($id: ID!) {
    removeCustomerSecondaryPhone(id: $id)
  }
`;
